import React, { SVGProps } from 'react'

const BigCloseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={30}
    fill="none"
    {...props}
  >
    <path
      fill="#3B3B3B"
      d="m21.615 6.616 1.768 1.768L16.767 15l6.616 6.616-1.768 1.768L15 16.767l-6.616 6.617-1.768-1.768L13.232 15 6.615 8.384l1.768-1.768 6.616 6.617 6.616-6.617Z"
    />
  </svg>
)
export default BigCloseIcon
